import { useEffect } from "react";

import { PreloadedQuery, usePreloadedQuery } from "react-relay";
import {
    AnchorPageRelayQuery,
    shapeAnchorContentfulResponse
} from "src/contentful";

import { anchorPageRelayQuery } from "@/__generated_contentful__/anchorPageRelayQuery.graphql";
import { PaidLandingPersonaTypes } from "@/utils/anchor-queries/get-anchor-contents";
import { AnchorContentsResponse } from "@/utils/anchor-queries/get-anchor-contents";
import { experiments, useExperimentExposure } from "@/utils/experiment";

import { ConfluenceSoftwarePageProps } from "./confluence-software-page";
import { ConfluencePagePaidLpConflAnchor } from "./paid-lp-confl-anchor";
import { getPageId } from "./subAnchors/subAnchor-util.tsx";

export interface ConfluencePageSubAnchorRelayProps
    extends ConfluenceSoftwarePageProps {
    anchorContents?: AnchorContentsResponse | null;
    queryRef?: PreloadedQuery<anchorPageRelayQuery>;
}

export const ConfluenceSoftwarePageVariantPaidLpConfSubAnchorsRelay = (
    pageProps: ConfluencePageSubAnchorRelayProps
) => {
    const [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure] =
        useExperimentExposure(experiments.cpapiDeprecationConfExperiment);
    const [exposureSubAnchorFired, fireSubAnchorExposure] =
        useExperimentExposure(experiments.cfind3254LandingPageSubAnchor);

    useEffect(() => {
        if (!exposureSubAnchorFired) {
            fireSubAnchorExposure();
        }
        if (!cpapiDeprecationExposureFired) {
            fireCpapiDeprecationExposure();
        }
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure,
        cpapiDeprecationExposureFired,
        fireCpapiDeprecationExposure
    ]);

    const data = usePreloadedQuery(
        AnchorPageRelayQuery,
        pageProps.queryRef ||
            (null as unknown as PreloadedQuery<anchorPageRelayQuery>)
    );
    pageProps = Object.assign({}, pageProps, {
        anchorContents: shapeAnchorContentfulResponse(data)
    });

    return (
        <ConfluencePagePaidLpConflAnchor
            {...pageProps}
            pageId={getPageId(pageProps.subAnchor)}
            persona={"unknown" as PaidLandingPersonaTypes}
            pageVariant="subAnchor"
            dataProductKey="confluence-PaidLpConflSubAnchor"
        />
    );
};
